<template>
  <div>

    <div class="mb-12">
        <divcard class="d-flex justify-space-between mb-2" style="gap: 24px">
          <div class="d-flex" style="gap: 24px">
            <div>
              <v-img
                  :src="require('../../assets/mhesr.png')"
                  min-width="100"
                  max-width="100"
                  aspect-ratio="1"
              ></v-img>
            </div>

            <div>
              <div class="page-title">สำนักงานปลัดกระทรวงอุดมศึกษาฯ (สป.อว.)</div>
              <div class="d-flex" style="gap: 18px">
                <Iconify
                    class="left-side d-flex justify-end"
                    size="15px"
                    icon="jam:clock"
                    color="var(--theme-color-nine)"
                ></Iconify>
                <div>วันที่เปิดรับโครงการ      31 พฤศจิกายน 2565 เวลา 00:00 น. - 30 ธันวาคม 2565 เวลา 12:00 น.</div>
              </div>

              <div class="d-flex" style="gap: 18px">
                <Iconify
                    class="left-side d-flex justify-end"
                    size="15px"
                    icon="jam:clock"
                    color="var(--theme-color-nine)"
                ></Iconify>
                <div>
                  <div>วันที่พิจารณาโครงการ    3 มกราคม 2566 เวลา 08:00 น. - 5 มกราคม 2566 เวลา 12:00 น.</div>
                  <div>โครงการส่งเสริมกิจการอุทยานวิทยาศาสตร์ (นิคมธุรกิจวิทยาศาสตร์ภูมิภาค)</div>
                </div>
              </div>
            </div>
          </div>

          <div class="budget-tag">
            <div>ปี งปม.</div>
            <div>2566</div>
          </div>
        </divcard>

        <StatusStep
            :current-step="currentStep"
            :steps="documentSteps"
            v-if="!$route.query.preview"
        ></StatusStep>
    </div>

    <!--  Form switcher  -->
    <div>
      <BFormGeneral v-if="currentStep === 1 && !$route.query.preview" :masterData="masterData" :is-same-id="isSameId()" :key="f1_formKey"></BFormGeneral>
      <BFormProject v-if="currentStep === 2" :masterData="masterData" :is-same-id="isSameId()" :key="f2_formKey"></BFormProject>
      <BFormPlan v-if="currentStep === 3" :masterData="masterData" :is-same-id="isSameId()" :key="f3_formKey"></BFormPlan>
      <BFormOOI v-if="currentStep === 4" :masterData="masterData" :is-same-id="isSameId()" :key="f4_formKey"></BFormOOI>
      <BFormAttachment v-if="currentStep === 5" :masterData="masterData" :is-same-id="isSameId()" :key="f5_formKey"></BFormAttachment>
      <BFormSummary v-if="currentStep === 6" :masterData="masterData" :is-same-id="isSameId()" :key="f6_formKey"></BFormSummary>
    </div>

    <!-- Action buttons -->
    <div class="d-flex justify-space-between">
      <Button theme="2" @onClick="onCancel">ยกเลิก</Button>

      <div class="flex-center" v-if="!$route.query.preview">
        <!-- For Dev -->
<!--        <Button theme="4" min-width="120px" :disabled="isLoading" @onClick="summaryForm">Summary</Button>-->
        <!-- /*For Dev -->
        <Button theme="3" min-width="120px" :disabled="isLoading" @onClick="backForm">&lt; ย้อนกลับ</Button>
        <Button theme="4" min-width="120px" :disabled="isLoading" @onClick="saveDraft">บันทึกฉบับร่าง</Button>
        <Button theme="3" min-width="120px" :disabled="isLoading" @onClick="nextForm">ถัดไป ></Button>
      </div>
    </div>

  </div>
</template>

<script>
import StatusStep from "../../components/StatusStep"
import Button from "../../components/input/Button"
import { eventBus } from "../../plugins/global-funcs"
import BFormGeneral from './B/BFormGeneral'
import BFormProject from './B/BFormProject'
import BFormPlan from "./B/BFormPlan"
import BFormOOI from "./B/BFormOOI"
import BFormAttachment from "./B/BFormAttachment"
import BFormSummary from "./B/BFormSummary"
import {mapState} from "vuex";

export default {
  name: "FormB",
  components: {
    StatusStep,
    Button,
    BFormGeneral,
    BFormProject,
    BFormPlan,
    BFormOOI,
    BFormAttachment,
    BFormSummary
  },
  data () {
    return {
      currentStep: 1,
      documentSteps: [
        {
          no: 1,
          name: 'ข้อมูลทั่วไป'
        },
        {
          no: 2,
          name: 'ข้อมูลโครงการ'
        },
        {
          no: 3,
          name: 'แผนการดำเนินงานวิจัย'
        },
        {
          no: 4,
          name: 'OOI'
        },
        {
          no: 5,
          name: 'เอกสารแนบ'
        }
      ],
      formGeneral: {},
      formProject: {},
      formPlan: {},
      formOOI: {},
      formAttachment: {},
      masterData: {},
      updateId: undefined,
      f1_formKey: 0,
      f2_formKey: 0,
      f3_formKey: 0,
      f4_formKey: 0,
      f5_formKey: 0,
      f6_formKey: 0,
    }
  },
  async created () {
    if (!this.$route.query.plan_id && !this.$route.query.form_a_id && !this.$route.query.id) return this.onCancel()
    await this.getMasterData()
    if(this.$route.query.preview) return this.summaryForm()
    this.retrieveForms()

    //for dev
    this.currentStep = 5
  },
  computed: {
    ...mapState({
      isLoading: state => state.General.isLoading,
      userInfo: state => state.Auth.User,
      bFormId: state => state.BForm.id
    })
  },
  methods: {
    isSameId () {
      return !!this.$route.query.id && (this.$route.query.id == this.bFormId)
    },
    backForm () {
      if (this.currentStep <= 1) return;
      // don't save when back from summary page
      if (this.currentStep <= this.documentSteps.length) {
        this.saveDraft()
      }
      this.currentStep -= 1
      this.$vuetify.goTo('#app')
    },
    nextForm () {
      if (this.currentStep > this.documentSteps.length) {
        this.saveDraft(true)
        return this.$router.push({ name: 'MainProjectOffer' })
      }
      this.saveDraft()
      this.currentStep += 1
      this.$vuetify.goTo('#app')
    },
    async saveDraft (isSubmit = false) {
      this.requestForm(this.currentStep)

      let payload = {
        form_ab_general_info: {
          ...this.formGeneral,
          kpi_quantity: this.formOOI.quantity,
          kpi_quality: this.formOOI.quality,
        },
        form_ab_project_info: this.formProject,
        project_section_plan: {
          ...this.formPlan,
          form_ab_budget: undefined
        },
        form_ab_budget: this.formPlan.form_ab_budget,
        operating_activities: this.formPlan.operating_activities,
        kpi_annex_projects: this.formOOI.kpi_annex_projects,
        kpi_values: this.formOOI.kpi_values,
        attachments: this.formAttachment ? this.formAttachment : []
      }

      if (this.$route.query.plan_id) payload.plan_id = this.$route.query.plan_id
      if (this.$route.query.form_a_id) payload.form_a_id = this.$route.query.form_a_id
      if (this.$route.query.inception_id) payload.inception_id = this.masterData.form_b.id

      let res
      if (this.$route.query.id || this.updateId) {
        // case: update
        payload = {
          id: this.$route.query.id || this.updateId,
          payload: {
            ...payload,
            id: undefined,
            status: isSubmit ? 'Submitted' : 'Draft'
          }
        }

        //check each this.formAttachment has a File or not
        for(let i = 0; i < payload.payload.attachments?.length; i++) {
          if (payload.payload.attachments[i] instanceof File) {
            console.log('has file')
            payload.payload.attachments[i] = await this.uploadFile(payload.payload.attachments[i])
          }
        }

        console.log('payload updated: ', payload)
        res = await this.$apiFire('BForm/updateFormB', payload)
        this.masterData.FormB = res;
        this.masterData.plan_master = res.plan_master;
        // update component with changing key
        this.f1_formKey += 1
        this.f2_formKey += 1
        this.f3_formKey += 1
        this.f4_formKey += 1
        this.f5_formKey += 1
        this.f6_formKey += 1
      } else {
        // case: store new
        payload.status = isSubmit ? 'Submitted' : 'Draft'
        console.log('payload store: ', payload)
        res = await this.$apiFire('BForm/storeFormB', payload)

        if (res) {
          this.updateId = res
          this.$store.commit('BForm/setGeneralForm', this.formGeneral)
          window.history.replaceState({} , null, window.location.href + '&id=' + res)
        }
      }
      // update changed data
      this.getMasterData()
      console.log(res)
    },
    requestForm (formStep) {
      switch (formStep) {
        case 1:
          eventBus.$emit('bFormGeneral')
          break

        case 2:
          eventBus.$emit('bFormProject')
          break

        case 3:
          eventBus.$emit('bFormPlan')
          break

        case 4:
          eventBus.$emit('bFormOOI')
          break

        case 5:
          eventBus.$emit('bFormAttachment')
          break

      }
    },
    retrieveForms () {
      // General form
      eventBus.$on('bFormGeneralSend', (form) => {
        this.formGeneral = form
        // keep in storage
        this.$store.commit('BForm/setGeneralForm', this.formGeneral)
      })

      // Project form
      eventBus.$on('bFormProjectSend', (form) => {
        this.formProject = form
        // keep in storage
        this.$store.commit('BForm/setProjectForm', this.formProject)
      })

      // Plan form
      eventBus.$on('bFormPlanSend', (form) => {
        this.formPlan = form
        // keep in storage
        this.$store.commit('BForm/setPlanForm', this.formPlan)
      })

      // OOI form
      eventBus.$on('bFormOOISend', (form) => {
        this.formOOI = form
        // keep in storage
        this.$store.commit('BForm/setOOIForm', this.formOOI)
      })

      // Attachment form
      eventBus.$on('bFormAttachmentSend', (form) => {
        this.formAttachment = form
        // keep in storage
        this.$store.commit('BForm/setAttachmentForm', this.formAttachment)
      })
    },
    async getMasterData () {
      let res
      // inception id as form a id
      // if (this.$route.query.inception_id) {
      //   res = await this.$apiFire('BForm/getEditMasterFormBInception', {
      //     form_a_id: this.$route.query.inception_id,
      //     plan_id: this.$route.query.plan_id
      //   })
      //   // update component with changing key
      //   this.f1_formKey += 1
      //   this.f2_formKey += 1
      //   this.f3_formKey += 1
      //   this.f4_formKey += 1
      //   this.f5_formKey += 1
      // } else {
        if (this.$route.query.id || this.updateId) {
          // edit (wait for api)
          let id = this.$route.query.id || this.updateId;
          res = await this.$apiFire('BForm/getEditMasterFormB', id)
          // update component with changing key
          this.f1_formKey += 1
          this.f2_formKey += 1
          this.f3_formKey += 1
          this.f4_formKey += 1
          this.f5_formKey += 1
          this.f6_formKey += 1
        } else {
          // create
          res = await this.$apiFire('BForm/getMasterFormB', this.$route.query.plan_id)
        }
      // }

      console.log(res)
      if (res) {
        this.masterData = res
      } else {
        this.onCancel()
      }
    },
    onCancel () {
      this.$router.push({ name: 'MainProjectOffer' })
    },
    async uploadFile(file){
      let formData = new FormData();
      formData.append('files[]', file);
      let payload = {
        files : formData
      }
      let res = await this.$apiFire('Attachment/uploadFile', formData)
      console.log('res@uploadFile', res)
      if (res.length > 0) {
        console.log('file uploaded', res[0])
        return res[0]
      }
    },
    summaryForm() {
      this.currentStep = 6
      this.$vuetify.goTo('#app')
    },
  }
}
</script>

<style scoped lang="scss">

</style>